import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  Typography,
} from "@mui/material";
import type { ReactNode } from "react";
import projectColors from "../../../../../theme/projectColors";
interface CustomDrawerItemProps {
  handleButton: () => void;
  title: string;
  icon: ReactNode;
}

function CustomDrawerItem({
  title,
  handleButton,
  icon,
}: CustomDrawerItemProps) {
  return (
    <ListItem
      sx={{
        my: 2,
        px: 0,
        py: 1,
        ":hover": {
          bgcolor: projectColors.primary.main,
        },
      }}
    >
      <ListItemButton
        onClick={() => {
          handleButton();
        }}
        sx={{
          justifyContent: "left",
          bgcolor: "inherit",
        }}
      >
        <ListItemIcon>{icon}</ListItemIcon>
        <Typography
          variant="h4"
          color="white"
          textAlign="left"
          sx={{ color: "white", fontWeight: "bold", bgcolor: "inherit" }}
        >
          {title}
        </Typography>
      </ListItemButton>
    </ListItem>
  );
}

export default CustomDrawerItem;
